var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWvP4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 490",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(91, 19, 229, 0)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(91, 19, 229, 0.19)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,0L80,65.3C160,131,320,261,480,302.2C640,343,800,294,960,228.7C1120,163,1280,82,1440,106.2C1600,131,1760,261,1920,294C2080,327,2240,261,2400,204.2C2560,147,2720,98,2880,130.7C3040,163,3200,278,3360,334.8C3520,392,3680,392,3840,375.7C4000,359,4160,327,4320,318.5C4480,310,4640,327,4800,294C4960,261,5120,180,5280,187.8C5440,196,5600,294,5760,277.7C5920,261,6080,131,6240,138.8C6400,147,6560,294,6720,367.5C6880,441,7040,441,7200,375.7C7360,310,7520,180,7680,171.5C7840,163,8000,278,8160,302.2C8320,327,8480,261,8640,212.3C8800,163,8960,131,9120,171.5C9280,212,9440,327,9600,310.3C9760,294,9920,147,10080,147C10240,147,10400,294,10560,318.5C10720,343,10880,245,11040,187.8C11200,131,11360,114,11440,106.2L11520,98L11520,490L11440,490C11360,490,11200,490,11040,490C10880,490,10720,490,10560,490C10400,490,10240,490,10080,490C9920,490,9760,490,9600,490C9440,490,9280,490,9120,490C8960,490,8800,490,8640,490C8480,490,8320,490,8160,490C8000,490,7840,490,7680,490C7520,490,7360,490,7200,490C7040,490,6880,490,6720,490C6560,490,6400,490,6240,490C6080,490,5920,490,5760,490C5600,490,5440,490,5280,490C5120,490,4960,490,4800,490C4640,490,4480,490,4320,490C4160,490,4000,490,3840,490C3680,490,3520,490,3360,490C3200,490,3040,490,2880,490C2720,490,2560,490,2400,490C2240,490,2080,490,1920,490C1760,490,1600,490,1440,490C1280,490,1120,490,960,490C800,490,640,490,480,490C320,490,160,490,80,490L0,490Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWvP4);
export default __webpack_public_path__ + "static/media/wv_p4.c69d8a6773604a2dd7a9a65b9947490c.svg";
export { ForwardRef as ReactComponent };